import { isDayjs } from 'dayjs';

import { TimePeriod, type Period } from '@/types/date';

const TIME_PERIOD_VALUES = new Set<string>(Object.values(TimePeriod));

export const isTimePeriod = (value: unknown): value is TimePeriod =>
  typeof value === 'string' && TIME_PERIOD_VALUES.has(value);

export const isPeriod = (value: unknown): value is Period => {
  if (typeof value !== 'object' || value === null) {
    return false;
  }

  return (
    'beginn' in value &&
    isDayjs(value.beginn) &&
    'end' in value &&
    isDayjs(value.end) &&
    'period' in value &&
    typeof value.period === 'string' &&
    isTimePeriod(value.period)
  );
};
